import React from "react";
import { IPlanRecurrency } from "~/types/types";
import * as palette from "@govlaunch/palette";
import ChangeBillingRecurrency from "~/components/makers/ChangeBillingRecurrency";
import ConfirmBillingRecurrencySwitch from "~/components/makers/ConfirmBillingRecurrencySwitch";
import { IStripePlanFieldsFragment } from "~/lib/queries/fragments/__generated__/StripePlanFields.generated";
import * as Types from "~/types/types";
import { FormattedMessage } from "react-intl";

interface ICurrentBillProps {
  stripePlan: Types.Maybe<{ __typename: "StripePlan" } & IStripePlanFieldsFragment>;
  freeSubscription?: boolean | null;
}

export default function CurrentBill({ stripePlan, freeSubscription = false }: ICurrentBillProps) {
  const currentPeriodBill = (recurrency: IPlanRecurrency) => {
    if (recurrency === IPlanRecurrency.Monthly) {
      return <FormattedMessage defaultMessage="Current Monthly Bill" id="exEZSV" />;
    }

    return <FormattedMessage defaultMessage="Current Yearly Bill" id="cnh8A0" />;
  };

  return (
    <>
      <div
        css={{
          fontSize: 16,
          fontWeight: 600,
          color: "#949195",
        }}
      >
        {stripePlan ? (
          currentPeriodBill(stripePlan.recurrency)
        ) : (
          <span>
            <FormattedMessage defaultMessage="Current Bill" id="xWHegU" />
          </span>
        )}
      </div>

      <div
        css={{
          display: "grid",
          gridRowGap: 8,
        }}
      >
        {freeSubscription ? (
          <strong
            css={{
              fontSize: 16,
              fontWeight: 600,
              color: palette.greenSuccess,
            }}
          >
            Free
          </strong>
        ) : (
          <strong
            css={{
              fontSize: 16,
              fontWeight: 600,
              color: palette.text,
            }}
          >
            {stripePlan ? <span>${(stripePlan.price / 100).toFixed(2)}</span> : <span>N/A</span>}
          </strong>
        )}

        <ChangeBillingRecurrency currentStripePlan={stripePlan}>
          {({ toPlan, canChangeToYearly, isChangingPlans, changeToYearly }) => {
            if (!stripePlan || !toPlan) {
              return null;
            }

            if (canChangeToYearly) {
              return (
                <ConfirmBillingRecurrencySwitch fromPlan={stripePlan} toPlan={toPlan} onConfirm={changeToYearly}>
                  {({ onConfirmBeforeSwitching }) => (
                    <button
                      type="button"
                      disabled={isChangingPlans}
                      onClick={onConfirmBeforeSwitching}
                      css={{
                        display: "inline-flex",
                        boxSizing: "border-box",
                        margin: 0,
                        padding: 0,
                        color: palette.innovatorBlue,
                        fontSize: 13,
                        lineHeight: 1.33,
                        backgroundColor: "transparent",
                        border: "none",
                        outline: "none",
                        cursor: isChangingPlans ? "default" : "pointer",
                        WebkitAppearance: "none",
                      }}
                    >
                      {isChangingPlans ? (
                        <FormattedMessage defaultMessage="Please wait..." id="172N3w" />
                      ) : (
                        <FormattedMessage defaultMessage="Switch to yearly billing" id="l1l9w8" />
                      )}
                    </button>
                  )}
                </ConfirmBillingRecurrencySwitch>
              );
            }

            return null;
          }}
        </ChangeBillingRecurrency>
      </div>
    </>
  );
}
